"use client";
import { type FC, useEffect, useRef, useState } from "react";

import { useRouter } from "next/navigation";

import { MenuOutlined } from "@ant-design/icons";

import { Popover } from "@/components/molecules/popover";

export type PopoverPrimaryProps = {
  offset?: number;
  items: {
    onClick?: () => void;
    href?: string;
    label: string;
    icons: {
      filled: any;
      outlined: any;
    };
  }[];
};
const PopoverPrimary: FC<PopoverPrimaryProps> = ({ items, offset }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const popoverRef = useRef<HTMLDivElement>(null);
  const router = useRouter();

  const handleClickOutside = (event: MouseEvent) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Popover.Root
        isOpen={isOpen}
        offset={offset}
        onOpenChange={() => setIsOpen((prev) => !prev)}
      >
        <Popover.Trigger>
          <MenuOutlined className="m-0 p-1 text-2xl text-aubergine-perl-700" />
        </Popover.Trigger>

        <Popover.Content>
          <div
            className="w-[231px] gap-2 bg-lilac-geode-100 shadow-md"
            ref={popoverRef}
          >
            {items.map((item, index) => (
              // <Link href={item.href ?? "#"} key={index}>
              <Popover.Item
                key={index}
                onClick={() => {
                  if (item?.href) router.push(item.href);
                  if (item.onClick) item.onClick();
                  handleLinkClick();
                }}
              >
                <span className="hidden group-hover:block">
                  {item.icons.filled}
                </span>
                <span className="block group-hover:hidden">
                  {item.icons.outlined}
                </span>
                {item.label}
              </Popover.Item>
              // </Link>
            ))}
          </div>
        </Popover.Content>
      </Popover.Root>
    </>
  );
};

export default PopoverPrimary;
